import { createAction } from './utils';
const reducer = 'DIALOGS';
const openDialog = createAction(reducer, 'OPEN');
const openDialogWithParams = createAction(reducer, 'OPEN_WITH_PARAMS');
const closeDialog = createAction(reducer, 'CLOSE');
export { openDialog, openDialogWithParams, closeDialog };
